import React from 'react';

const ClearAllConfirmationModal = ({ openClearAllDialog, setOpenClearAllDialog, handleClearAll }) => {
  if (!openClearAllDialog) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white/95 rounded-3xl p-8 max-w-md w-full shadow-2xl transform animate-scale-in border border-pink-200">
        <h3 className="text-2xl font-bold text-gray-900 mb-3">Clear All Expenses</h3>
        <p className="text-gray-600 mb-6 text-base">Are you sure you want to delete ALL expenses? This action cannot be undone.</p>
        <div className="flex gap-3">
          <button
            onClick={() => setOpenClearAllDialog(false)}
            className="flex-1 px-5 py-2.5 bg-gray-100 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-200 font-semibold transition-all shadow-sm hover:shadow-md"
          >
            Cancel
          </button>
          <button
            onClick={handleClearAll}
            className="flex-1 px-5 py-2.5 bg-gradient-to-r from-red-500 to-pink-600 text-white font-semibold rounded-xl hover:from-red-600 hover:to-pink-700 shadow-md hover:shadow-lg transition-all"
          >
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClearAllConfirmationModal;
